import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { visitorMessages } from 'src/features/visitor/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { STAY_TYPE } from 'src/features/stay/types';

type ActiveStaySidePanelButtonsProps = {
    stayId?: string;
    stayType: STAY_TYPE;
};

const ActiveStaySidePanelButtons = ({ stayId, stayType }: ActiveStaySidePanelButtonsProps) => {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();

    const activePastStayUrlPart = stayType === 'active' ? 'active-stays' : 'past-stays';
    return (
        <>
            <div className="grid gap-2">
                <Button
                    variant="outline"
                    className="cursor-pointer"
                    onClick={() =>
                        stayId && navigate(`/visitors/${activePastStayUrlPart}/dashboard/${stayId}?type=${stayType}`)
                    }
                >
                    {formatMessage(visitorMessages.openStayDashboard)}
                </Button>
                {stayType === STAY_TYPE.ACTIVE && (
                    <Button className="cursor-pointer" variant="destructiveLight">
                        {formatMessage(visitorMessages.exitFromParking)}
                    </Button>
                )}
            </div>
        </>
    );
};

export default ActiveStaySidePanelButtons;
